import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const API_URL = process.env.VUE_APP_MANAGER_API_URL;
document.title = "Voyado Onsite Manager";

export default createStore({
  state: {
    callLogSite: "",
    title: "Home",
    apiURL: API_URL,
    loader: false,
    prevCompanyId: "",
    activeRoute: "",
    cognitoInfo: {},
    faceBookpopup: [],
    dashboardInfo: {},
    menudataInfo: {},
    routedataInfo: {},
    filterInfo: {},
    dashboardFilter: {},
    leads: {},
    headerSidebar: {},
    emailforforgotpassword: "",
    integrationsValue: "Shopware",
    moduleValue: "Accelerator",
    errorLogSite: "",
    errorIntegrationsValue: "",
    errorModuleValue: "",
    email: "",
    isFacebook: false,
    isTiktok: false,
    session: "",
    accProducts: "0",
    accOrder: "0",
    orderIntegrationsValue: "",
    accMarket: "0",
    accContact: "0",
    contactIntegrationsValue: "",
    accInventory: "0",
    inventoryIntegrationsValue: "",
    accReceipt: "0",
    receiptIntegrationsValue: "",
    isMultiPromotionsEnable: false,
    // isTargetingAndBehaviourEnable: false,
    isEnableMediaComponent: false,
    isEnableDeprecatedSite: false,
    notifiedErrorCount: -1,
    globalSearch: {
      value: "",
      matchMode: "contains", // You can adjust this based on your needs
    },
    selectedLanguage: "en",
    routes: [
      { Name: "/", Value: "home" },
      { Name: "/essence", Value: "essence" },
      { Name: "/deals", Value: "modifydeal" },
      { Name: "/site/list", Value: "sitelist" },
      { Name: "/site/create", Value: "sitecreate" },
      { Name: "/site/edit/:id", Value: "siteedit" },
      { Name: "/sites", Value: "newsitelist" },
      { Name: "/acceleratorsite", Value: "acceleratorsite" },
      { Name: "/acceleratorsite/:id", Value: "acceleratoredit" },
      { Name: "/leadads", Value: "leadadslist" },
      { Name: "/elevatelist", Value: "elevatelist" },
      { Name: "/elevatelist/:id", Value: "elevateedit" },
      { Name: "/newsite/create", Value: "newsitecreate" },
      { Name: "/newsite/edit/:id", Value: "newsiteedit" },
      { Name: "/newsite/copy/:id", Value: "newsitecopy" },
      { Name: "/site/copy/:id", Value: "sitecopy" },
      // { Name: "/deal/create", Value: "dealcreate" },
      { Name: "/performance", Value: "performance" },
      { Name: "/myambassadors", Value: "myambassadors" },
      { Name: "/myfriends", Value: "myfriends" },
      { Name: "/relations", Value: "relations" },
      { Name: "/user/list", Value: "userlist" },
      { Name: "/user/create", Value: "usercreate" },
      { Name: "/user/edit/:id", Value: "useredit" },
      { Name: "/companies", Value: "companylist" },
      { Name: "/company/create", Value: "companycreate" },
      { Name: "/company/edit/:id", Value: "companyedit" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/contact/list", Value: "contactlist" },
      { Name: "/errorsummary", Value: "errorsummary" },
      { Name: "/calllog", Value: "calllogsite" },
      { Name: "/calllog/:id", Value: "calllogdashboard" },
      { Name: "/calllog/:id/:keyid", Value: "calllogview" },
      { Name: "/sessiondashboard", Value: "sessionssite" },
      { Name: "/sessiondashboard/:id", Value: "sessionsdashboard" },
      { Name: "/sessiondashboard/:id/:keyid", Value: "sessionsview" },
      { Name: "/sessionlogdashboard", Value: "sessionlogsite" },
      { Name: "/sessionlogdashboard/:id", Value: "sessionlogdashboard" },
      { Name: "/sessionlogdashboard/:id/:keyid", Value: "sessionlogview" },
      // { Name: "/errorlog", Value: "errorsite" },
      // { Name: "/errorlog/:id", Value: "errordashboard" },
      { Name: "/errorlogbycompany", Value: "companyerrordashboard" },
      { Name: "/errorlogbycompany/:id", Value: "companyerrorview" },
      { Name: "/sitechangelog/:id", Value: "siteChangelog" },
      { Name: "/companychangelog/:id", Value: "companyChangelog" },
      { Name: "/editdeal/:id", Value: "editdealnew" },
      { Name: "/newonsitemessage", Value: "newonsitemessage" },

      { Name: "/deals/deallist", Value: "managedeallistnew" },
      { Name: "/copydealnew/:id", Value: "copydeal" },
      { Name: "/copydeal/:id", Value: "copydealnew" },
      { Name: "/searchdeal/:id", Value: "dealsearch" },
      { Name: "/deals/create", Value: "managedealupdateCreate" },
      { Name: "/deals/edit/:id", Value: "managedealupdateById" },
      {
        Name: "/updatetranslation",
        Value: "updatetranslation",
      },
      { Name: "/notfound", Value: "notfound" },
      { Name: "/signupwizard", Value: "signupwizard" },
      // { Name: "/managedealupdate", Value: "managedealupdate" },
      { Name: "/overview", Value: "overview" },
      { Name: "/contentgenerator", Value: "contentgenerator" },
      { Name: "/aicontent", Value: "aicontent" },
      { Name: "/aivideocontent", Value: "aivideocontent" },
      { Name: "/leadads/:id", Value: "leadads" },
      // { Name:"/acceleratordashboard", Value:"acceleratordashboard"},
      { Name: "/acceleratordashboard/products", Value: "productsite" },
      { Name: "/acceleratordashboard/products/:id", Value: "productdashboard" },
      {
        Name: "/acceleratordashboard/products/:id/:keyid",
        Value: "productview",
      },
      { Name: "/acceleratordashboard/orders", Value: "ordersite" },
      { Name: "/acceleratordashboard/orders/:id", Value: "orderdashboard" },
      { Name: "/acceleratordashboard/orders/:id/:keyid", Value: "orderview" },
      { Name: "/acceleratordashboard/contacts", Value: "contactsite" },
      { Name: "/acceleratordashboard/contacts/:id", Value: "contactdashboard" },
      {
        Name: "/acceleratordashboard/contacts/:id/:keyid",
        Value: "contactview",
      },
      { Name: "/acceleratordashboard/inventories", Value: "inventorysite" },
      {
        Name: "/acceleratordashboard/inventories/:id",
        Value: "inventorydashboard",
      },
      {
        Name: "/acceleratordashboard/inventories/:keyid/:siteId",
        Value: "inventoryview",
      },
      { Name: "/acceleratordashboard/markets", Value: "marketsite" },
      { Name: "/acceleratordashboard/markets/:id", Value: "marketdashboard" },
      { Name: "/acceleratordashboard/markets/:id/:keyid", Value: "marketview" },

      { Name: "/acceleratordashboard/receipt", Value: "receiptsite" },
      { Name: "/acceleratordashboard/receipt/:id", Value: "receiptdashboard" },
      {
        Name: "/acceleratordashboard/receipt/:id/:keyid",
        Value: "receiptview",
      },
      { Name: "/essence", Value: "essence" },
      { Name: "/onsitedashboard", Value: "onsitedashboard" },
      { Name: "/blank", Value: "blank" },
    ],
    // New state properties for URL parameters
    tenant: "",
    origin: "",
    emailParam: "",
    language: "",
    expectedIssuer: "",
    expectedAudience: "",
    organization: "",
    connection: "",
    refreshtoken: "",
    accesstoken: "",
  },
  plugins: [
    createPersistedState({
      paths: [
        "cognitoInfo",
        "dashboardInfo",
        "filterInfo",
        "dashboardFilter",
        "menudataInfo",
        "routedataInfo",
        "faceBookpopup",
        "selectedLanguage",
        "headerSidebar",
        "leads",
        "integrationsValue",
        "moduleValue",
        "isFacebook",
        "isTiktok",
        "accProducts",
        "accOrder",
        "orderIntegrationsValue",
        "accMarket",
        "accContact",
        "contactIntegrationsValue",
        "accInventory",
        "inventoryIntegrationsValue",
        "accReceipt",
        "receiptIntegrationsValue",
        "isMultiPromotionsEnable",
        // "isTargetingAndBehaviourEnable",
        "isEnableMediaComponent",
        "isEnableDeprecatedSite",
        "callLogSite",
        "errorLogSite",
        "errorIntegrationsValue",
        "errorModuleValue",
        "notifiedErrorCount",
        "email",
        // New persisted state for URL parameters
        "tenant",
        "origin",
        "emailParam",
        "language",
        "expectedIssuer",
        "expectedAudience",
        "organization",
        "connection",
        "refreshtoken",
        "accesstoken",
      ],
    }),
  ],
  getters: {
    GetRoutePath: (state) => (pathName) => {
      var routeObj = state.routes.filter(function (path) {
        if (path.Value == pathName) {
          return path.Name;
        }
      });
      if (routeObj.length > 0) {
        return routeObj[0].Name;
      }
    },
    getGlobalSearch: (state) => {
      return state.globalSearch;
    },
  },
  mutations: {
    setCallLogsSite(state, value) {
      state.callLogSite = value;
    },
    resetCallLogLogout(state) {
      state.callLogSite = "";
    },
    setErrorLogsSite(state, value) {
      state.errorLogSite = value;
    },
    resetErrorLogsSite(state) {
      state.errorLogSite = "";
    },

    setErrorIntegrationsValue(state, value) {
      state.errorIntegrationsValue = value;
    },
    resetErrorIntegrationsValue(state) {
      state.errorIntegrationsValue = "";
    },
    setErrorModuleValue(state, value) {
      state.errorModuleValue = value;
    },
    resetErrorModuleValue(state) {
      state.errorModuleValue = "";
    },

    setFacebook(state, value) {
      state.isFacebook = value;
    },
    setTiktok(state, value) {
      state.isTiktok = value;
    },
    resetFacebook(state) {
      state.isFacebook = false;
    },
    resetTiktok(state) {
      state.isTiktok = false;
    },
    setIntegrationsValue(state, value) {
      state.integrationsValue = value;
    },
    setModuleValue(state, value) {
      state.moduleValue = value;
    },
    setAcceleratorProducts(state, value) {
      state.accProducts = value;
    },
    setAcceleratorOrders(state, value) {
      state.accOrder = value;
    },
    setOrderIntegrationsValue(state, value) {
      state.orderIntegrationsValue = value;
    },
    setAcceleratorMarket(state, value) {
      state.accMarket = value;
    },
    setAcceleratorContact(state, value) {
      state.accContact = value;
    },
    setContactIntegrationsValue(state, value) {
      state.contactIntegrationsValue = value;
    },
    setAcceleratorInventory(state, value) {
      state.accInventory = value;
    },
    setInventoryIntegrationsValue(state, value) {
      state.inventoryIntegrationsValue = value;
    },
    setAcceleratorReceipt(state, value) {
      state.accReceipt = value;
    },
    setReceiptIntegrationsValue(state, value) {
      state.receiptIntegrationsValue = value;
    },
    setMultiPromotionsEnabled(state, value) {
      state.isMultiPromotionsEnable = value;
    },
    // setTargetingAndBehaviourEnabled(state, value) {
    //   state.isTargetingAndBehaviourEnable = value;
    // },
    setMediaLibraryEnabled(state, value) {
      state.isEnableMediaComponent = value;
    },
    setDeprecatedEnabled(state, value) {
      state.isEnableDeprecatedSite = value;
    },
    setNotifiedErrorCount(state, value) {
      state.notifiedErrorCount = value;
    },
    resetNotifiedErrorCount(state) {
      state.notifiedErrorCount = -1;
    },
    resetAcceleratorProducts(state) {
      state.accProducts = "0";
    },
    resetAcceleratorOrders(state) {
      state.accOrder = "0";
    },
    resetOrderIntegrationsValue(state) {
      state.orderIntegrationsValue = "";
    },
    setFacebookPopupWindowFalse(state, siteId) {
      const popupItem = state.faceBookpopup.find(
        (item) => item.siteid === siteId
      );
      if (popupItem) {
        popupItem.faceBookPopupwindow = false;
      }
    },

    resetAcceleratorMarket(state) {
      state.accMarket = "0";
    },
    resetAcceleratorContact(state) {
      state.accContact = "0";
    },
    resetContactIntegrationsValue(state) {
      state.contactIntegrationsValue = "";
    },
    resetAcceleratorInventory(state) {
      state.accInventory = "0";
    },
    resetInventoryIntegrationsValue(state) {
      state.inventoryIntegrationsValue = "";
    },
    resetAcceleratorReceipt(state) {
      state.accReceipt = "0";
    },
    resetReceiptIntegrationsValue(state) {
      state.receiptIntegrationsValue = "";
    },
    resetIntegrationsValue(state) {
      state.integrationsValue = "Shopware";
    },
    resetModuleValue(state) {
      state.moduleValue = "Accelerator";
    },
    setHeaderSidebar(state, headerSidebar) {
      state.headerSidebar = headerSidebar;
    },
    resetHeaderSidebar(state) {
      state.headerSidebar = {};
    },

    setSelectedLanguage(state, language) {
      state.selectedLanguage = language;
    },
    setGlobalSearch(state, search) {
      state.globalSearch = search;
    },
    showLoader(state) {
      state.loader += 1;
    },
    hideLoader(state) {
      if (state.loader > 0) state.loader -= 1;
      else state.loader = 0;
    },
    replaceTitle(state, newtitle) {
      state.title = newtitle;
      document.title = "Voyado Onsite Manager - " + newtitle;
    },
    setForgotPasswordEmail(state, info) {
      state.emailforforgotpassword = info;
    },
    resetForgotPasswordEmail(state) {
      state.emailforforgotpassword = "";
    },
    setLoginEmail(state, info) {
      state.email = info;
    },
    resetLoginEmail(state) {
      state.email = "";
    },
    setSession(state, info) {
      state.session = info;
    },
    resetSession(state) {
      state.session = "";
    },
    setCognitoToken(state, info) {
      state.cognitoInfo.token = info;
    },
    setCognitoRefreshToken(state, info) {
      state.refreshtoken = info;
    },
    setCognitoAccessToken(state, info) {
      state.accesstoken = info;
    },
    setFaceBookpopupSite(state, info) {
      const existing = state.faceBookpopup.find(
        (item) => item.siteid === info.siteid
      );
      if (!existing) {
        state.faceBookpopup.push({
          siteid: info.siteid,
          faceBookPopupwindow: false,
        });
      }
    },

    setFaceBookpopupOpen(state, info) {
      const existing = state.faceBookpopup.find(
        (item) => item.siteid === info.siteid
      );
      if (existing) {
        existing.faceBookPopupwindow = info.faceBookPopupwindow;
      } else {
        state.faceBookpopup.push({
          siteid: info.siteid,
          faceBookPopupwindow: info.faceBookPopupwindow ?? false,
        });
      }
    },

    resetFacebookPopup(state) {
      state.faceBookpopup = [];
    },

    setCognitoUsername(state, info) {
      state.cognitoInfo.username = info;
    },
    setCognitoEmail(state, info) {
      state.cognitoInfo.email = info;
    },
    setLeadsData(state, info) {
      state.leads.isLead = info;
    },
    setEcomData(state, info) {
      state.leads.isEcom = info;
    },
    setisElevateEnableData(state, info) {
      state.leads.isElevate = info;
    },
    setisShowOnSiteMessages(state, info) {
      state.leads.isShowOnSiteMessage = info;
    },
    setCompanystoreId(state, info) {
      state.leads.companystoreid = info;
    },
    setCognitoInfo(state, info) {
      state.cognitoInfo = info;
    },
    resetCognitoInfo(state) {
      state.cognitoInfo = {};
    },
    resetLead(state) {
      state.leads = {};
    },
    setMenudataInfo(state, info) {
      state.menudataInfo = info;
    },
    resetMenudataInfo(state) {
      state.menudataInfo = {};
    },
    setRoutedataInfo(state, info) {
      state.routedataInfo = info;
    },
    resetRoutedataInfo(state) {
      state.routedataInfo = {};
    },
    replaceCompanyId(state, newid) {
      state.cognitoInfo.companyid = newid;
      state.prevCompanyId = newid;

      state.cognitoInfo.companylist.forEach((element) => {
        element.selected = false;
      });

      var _filtered = state.cognitoInfo.companylist.filter(
        (a) => a.value == newid
      )[0];
      _filtered.selected = true;
      state.cognitoInfo.companyname = _filtered.text;
    },
    resetDashbboardInfoData(state) {
      state.dashboardInfo.data = "";
    },
    setDashboardInfo(state, info) {
      state.dashboardInfo = info;
    },
    resetDashboardInfo(state) {
      state.dashboardInfo = {};
    },
    resetDashboardLastSync(state) {
      state.dashboardInfo.lastSync = null;
    },
    resetDashbboardFilter(state) {
      state.dashboardFilter = "";
    },
    setDashboardFilter(state, filter) {
      state.dashboardFilter = filter;
    },
    setGlobalFilter(state, text) {
      state.filterInfo.global = text;
    },
    resetDealFilter(state) {
      state.filterInfo = {};
    },
    removeGlobalFilter(state) {
      state.filterInfo.global = "";
    },
    setActiveRoute(state, value) {
      state.activeRoute = value;
    },
    // New mutations for URL parameters, preserving existing values unless logout
    setTenant(state, value) {
      if (value) state.tenant = value; // Only update if value is provided
    },
    setOrigin(state, value) {
      if (value) state.origin = value; // Only update if value is provided
    },
    setEmailParam(state, value) {
      if (value) state.emailParam = value; // Only update if value is provided
    },
    setLanguage(state, value) {
      if (value) state.language = value; // Only update if value is provided
    },
    setExpectedIssuer(state, value) {
      if (value) state.expectedIssuer = value; // Only update if value is provided
    },
    setExpectedAudience(state, value) {
      if (value) state.expectedAudience = value; // Only update if value is provided
    },
    setOrganization(state, value) {
      if (value) state.organization = value; // Only update if value is provided
    },
    setConnection(state, value) {
      if (value) state.connection = value; // Only update if value is provided
    },
    // New mutation to clear these fields only on logout
    resetOnLogout(state) {
      state.tenant = "";
      state.origin = "";
      state.emailParam = "";
      state.language = "";
      state.expectedIssuer = "";
      state.expectedAudience = "";
      state.organization = "";
      state.connection = "";
      state.cognitoInfo = {};
      state.accesstoken = "";
      state.refreshtoken = "";
    },
  },
});